// Remembers that we sent this browser to the shop's cart permalink, so coming back shows the "added" state.
import { devWarn } from "./log";

const key = (id, height) => `duckify_cart_sent_${id}_${height}`;

export const markCartSent = (id, height) => {
  try {
    sessionStorage.setItem(key(id, height), String(Date.now()));
  } catch (e) {
    devWarn("cartSent: sessionStorage unavailable (private mode?)", e?.message);
  }
};

export const wasCartSent = (id, height) => {
  try {
    return !!sessionStorage.getItem(key(id, height));
  } catch {
    return false;
  }
};
